module.exports = __webpack_public_path__ + "static/media/plus.94d6e8b7.svg";